import Close from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Avatar,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_CHANGE_TRACKER } from "../../constant/Apipath";
import { ClientChangeTrackerViewModel } from "./ClientChangeTrackerViewModel";
import { BILightGrey } from "../../assets/helpers";

export default function ChangeTrackerListView({ open, onClose, data }) {
  const [pageNO, setPageNO] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [recordingData, setRecordingData] = useState([]);
  const { loginData, selectedClientData } = useSelector((state) => state?.main);

  useEffect(() => {
    if (open) fetchChangeTracker();
  }, [open]);

  const fetchChangeTracker = async () => {
    let obj = {
      PageNr: pageNO,
      NrOfRecPerPage: 20,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [{ FieldName: "dateCreated", Direction: "DESC" }],
      SearchList: [
        {
          clientEmployeeJobId: data.id
        },
      ],
    };

    let res = await Postrequestcall(
      FETCH_CLIENT_CHANGE_TRACKER,
      obj,
      loginData?.accessToken,
    );

    if (res.status === 200) {
      if (res?.data?.data?.length > 0) {
        setHasMore(true);
        setPageNO((prev) => prev + 1);

        let temp = [];
        res?.data?.data?.map((data) => {
          temp.push({
            ...data,
            isPlaying: false,
          });
        });

        setRecordingData((prev) => [...prev, ...temp]);
      } else {
        setHasMore(false);
      }
    }
  };

  const handelClose = () => {
    onClose();
    setPageNO(1);
    setHasMore(true);
    setRecordingData([]);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handelClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="client-modal-responsive">
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
            className="action-button-container"
          >
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              <LocationOnIcon
                style={{
                  color: selectedClientData?.AccentColor,
                  marginRight: "10px",
                }}
              />
              {`${data?.jobCode} - ${data?.jobName} `}
            </Typography>
            <IconButton onClick={() => handelClose()}>
              <Close
                sx={{
                  color:
                    selectedClientData?.AccentColor !== undefined &&
                      selectedClientData?.AccentColor
                      ? selectedClientData?.AccentColor
                      : BILightGrey,
                }}
              />
            </IconButton>
          </div>

          <InfiniteScroll
            dataLength={recordingData?.length}
            next={fetchChangeTracker}
            hasMore={hasMore}
            loader={<Loader />}
            height={400}
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              scrollbarWidth: "none",
            }}
          >
            {recordingData?.map((item, index) => (
              <Listing key={index} index={index} item={item} />
            ))}
          </InfiniteScroll>
        </div>
      </Modal>
    </>
  );
}

const Listing = ({ item, index }) => {
  const [viewModal, setViewModal] = useState(false);
  return (
    <div key={index}>
      <Grid
        container
        size={12}
        sx={{ mb: 1 }}
        onClick={() => {
          setViewModal(true);
        }}
        style={{
          padding: "0",
          borderRadius: "10px",
          cursor: "pointer",
          border: "1px solid #e4e4e4",
        }}
      >
        <Grid sx={{ padding: 1 }} size={12}>
          <Stack
            direction={"row"}
            sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 1.5 }}
          >
            <Avatar src={item?.userProfilePicture} />
            <Stack sx={{ flexGrow: 1, width: "100%" }} direction="column">
              <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction="row">
                <Typography sx={{ fontSize: 15 }} variant="subtitle2">
                  {item?.clientEmployeeName}
                </Typography>
                <Typography
                  sx={{ fontSize: 15 }}
                  style={{
                    color: "grey",
                  }}
                >
                  {dayjs(item?.date).format("MMMM DD, YYYY")}
                </Typography>
              </Stack>
              <Typography
                sx={{
                  wordBreak: "break-all",
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                }}
              >
                {item?.description}
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <ClientChangeTrackerViewModel
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
        data={item}
      />
    </div>
  );
};
